import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-background" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Send Magic Link", -1)
const _hoisted_4 = {
  key: 0,
  class: "login-spinner"
}

import { ref } from "vue";
import { login } from "@/refs/account";
import { showLoginModal } from "@/refs/modals";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthModal',
  setup(__props) {

const email = ref<string>("");

const showSpinner = ref<boolean>(false);

const loginAndClose = async () => {
	showSpinner.value = true;

	try {
		await login(email.value);
	} catch (err) {
		console.warn(err);
	}

	showSpinner.value = false;
	showLoginModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title"),
      _renderSlot(_ctx.$slots, "input", {}, () => [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "steve@apple.com",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
        }, null, 512), [
          [_vModelText, email.value]
        ])
      ]),
      _renderSlot(_ctx.$slots, "button", {}, () => [
        _createElementVNode("button", {
          onClick: loginAndClose,
          class: "button-modal"
        }, [
          _renderSlot(_ctx.$slots, "button-text", {}, () => [
            _hoisted_3
          ]),
          (showSpinner.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "extra")
    ])
  ]))
}
}

})